import { useState, useEffect } from "react";

const getWidth = () =>
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;

export function useCurrentWidth() {
  let [matches, setMatches] = useState(
    window.matchMedia("(min-width: 1024px)").matches
  );

  // in this case useEffect will execute only once because
  // it does not have any dependencies.
  useEffect(() => {
    window
      .matchMedia("(min-width: 1024px)")
      .addEventListener("change", (e) => setMatches(e.matches));
  }, []);

  return matches;
}
